import React from "react";

const Stat_Box_Plots = () => {
  return (
    <div>
      <h1>Stat Box Plots</h1>
    </div>
  );
};

export default Stat_Box_Plots;
